import React from 'react';
import './index.scss';
import { Mask } from 'antd-mobile';
interface initProps {
  children?: any; //自组件弹框
  show: boolean;
  maskClick?: () => void;
}
const BaseModal = (props: initProps) => {
  const { children, show, maskClick } = props;
  /**
   * @description: 点击遮罩层事件
   */
  const onMaskClick = () => {
    maskClick && maskClick();
  };
  return (
    <div className="base-modal">
      <Mask visible={show} onMaskClick={onMaskClick} color='white'>
        <div className="modal__content">{children}</div>
      </Mask>
    </div>
  );
};

export default BaseModal;
